import { Skeleton } from '@shared/components/ui/shadcn';

export const FeaturesSkeleton = () => {
  return (
    <div className="space-y-4 mb-6 pb-8 gap-4 grid grid-cols-1 md:grid-cols-5 pt-4 border-b border-card-border">
      <div className="col-span-1 md:col-span-2">
        <Skeleton className="h-5 w-44 bg-hover-press" />
      </div>
      <div className="col-span-1 md:col-span-3 !mt-0">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="flex items-start gap-3">
              <Skeleton className="w-4 h-4 mt-1 rounded-full bg-hover-press" />
              <div className="space-y-2 w-full">
                <Skeleton className="h-4 w-40 bg-hover-press" />
                <Skeleton className="h-3 w-56 bg-hover-press" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
